import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { BaseFormFieldComponent } from "../base-form-field.component";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { dateToDatabaseFormat, dateToDateInLocalTimezone } from "src/services/utils/date.utils";
import { isDateOnlyString, tryParseDate } from "src/services/utils/timestamp.utils";
import { SelectDatetimeEvent } from "../../../../../shared/ion-components-events.interface";
import { format } from "date-fns";
import { generateRandomString } from "src/services/utils/string.utils";

@Component({
  selector: "rc-date-form-field",
  templateUrl: "./date-form-field.component.html",
  styleUrls: ["./date-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DateFormFieldComponent,
    },
  ],
  standalone: false,
})
export class DateFormFieldComponent extends BaseFormFieldComponent<string> implements OnInit {
  @Input() public errorText: string | undefined;
  @Input() public minDate?: string;
  @Input() public blocked = false;
  @ViewChild("datePopover", { read: ElementRef }) private datePopover?: ElementRef<HTMLIonPopoverElement>;

  public idSuffix = generateRandomString();
  public dateForInput: string;

  public constructor() {
    super();
  }

  public async ngOnInit(): Promise<void> {
    this.minDate ??= dateToDatabaseFormat(new Date());
    super.ngOnInit();
  }

  public async toDisplayValue(input: string): Promise<string> {
    if (!input) {
      this.dateForInput = "";
      return "";
    }

    const parsed = tryParseDate(input);
    if (!parsed) {
      return "";
    }
    const dateAsInLocalTimezone = isDateOnlyString(input) ? parsed : dateToDateInLocalTimezone(parsed);
    const dateDisplayString = dateToDatabaseFormat(dateAsInLocalTimezone);

    this.dateForInput = dateDisplayString;

    if (this.dateForInput != input) {
      await this.onInputChangeInternal(this.dateForInput);
    }

    return dateDisplayString;
  }

  public async onInputChange(event: unknown): Promise<void> {
    const eventCast = event as SelectDatetimeEvent;
    const selectedValue = eventCast.detail.value;
    if (!selectedValue) {
      return;
    }

    const isTimestamp = selectedValue.includes("T");
    const dateString = isTimestamp ? format(new Date(selectedValue), "yyyy-MM-dd") : selectedValue;

    await this.onInputChangeInternal(dateString);
  }

  public openCalendar() {
    if (this.disabled || this.blocked) {
      return;
    }

    const popover = this.datePopover?.nativeElement;
    if (!popover) {
      return;
    }

    popover.isOpen = true;
    popover.addEventListener("didDismiss", () => (popover.isOpen = false));
  }
}
